import { render, staticRenderFns } from "./ReviewRequests.vue?vue&type=template&id=f0ff7832&"
import script from "./ReviewRequests.vue?vue&type=script&lang=js&"
export * from "./ReviewRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports